import { defineRecipe } from '@chakra-ui/react';

export const iconRecipe = defineRecipe({
  base: {
    height: '20px',
    width: '20px',
    color: 'gray.500',
  },
});

export default iconRecipe;
